import { Button } from "@fc/devteam-components-library";

export default function ButtonDissabled(props: {label: string, action: () => void}) {
    const { label, action } = props
    return (
        <div
            className="Button-Dissabled"
            onClick={action}
        >
            <Button
                buttontype="button"
                buttontext={label}
            />
        </div>
    )
}